module.exports = __webpack_public_path__ + "static/halohalo-6b071ca141c970a95587136f470c7690.jpg";